module.exports = __webpack_public_path__ + "img/886612d.jpg";